"use client";

import React from "react";
import { PiggyBank, ShieldCheck, Zap, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Ahorro Económico",
  description: "Reparar tu batería en BateríasSevilla supone un ahorro significativo frente a la compra de una nueva, ofreciendo el mejor servicio de reparación de baterías de litio en Sevilla, Mairena del Aljarafe, el Aljarafe y toda España.",
  icon: PiggyBank
}, {
  title: "Diagnóstico Preciso",
  description: "Como servicio técnico de baterías en Andalucía, Mairena del Aljarafe y el Aljarafe, utilizamos tecnología de vanguardia para un diagnóstico profesional y preciso de cada celda y componente BMS.",
  icon: ShieldCheck
}, {
  title: "Máxima Potencia",
  description: "Somos expertos en reparar batería patinete Sevilla, Mairena del Aljarafe y el Aljarafe, así como bicicletas eléctricas, devolviendo la autonomía original a tu vehículo con soluciones técnicas de alta calidad.",
  icon: Zap
}];
export default function ScooterAndBicycleBatterySolutions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="soluciones-para-baterías-de-patinetes-y-bicicletas" className="relative w-full bg-background py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.15] dark:opacity-[0.05]" style={{
      backgroundImage: `linear-gradient(to right, var(--border) 1px, transparent 1px), linear-gradient(to bottom, var(--border) 1px, transparent 1px)`,
      backgroundSize: '32px 32px'
    }} aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`mx-auto max-w-3xl text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4 tracking-tight">
            Soluciones Avanzadas para tu Movilidad
          </h1>
          <p className="text-lg text-muted-foreground font-default max-w-2xl mx-auto">
            Descubre los beneficios de confiar en BateríasSevilla para el mantenimiento y reparación de las baterías de tus vehículos eléctricos en Mairena del Aljarafe y el Aljarafe.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {benefits.map((benefit, i) => <Card key={i} data-index={i} className="group relative overflow-hidden bg-card/80 backdrop-blur-sm border-border transition-all duration-500 hover:-translate-y-2 hover:border-primary/50 hover:shadow-xl hover:shadow-primary/10">
              {}
              <div className="absolute inset-0 opacity-0 transition-opacity duration-500 group-hover:opacity-10 pointer-events-none" style={{
            background: `radial-gradient(circle at center, var(--primary) 0%, transparent 70%)`
          }} aria-hidden="true" />
              
              <CardHeader className="relative z-10 flex flex-col items-center text-center pb-2">
                <div className="mb-6 inline-flex h-20 w-20 items-center justify-center rounded-2xl bg-secondary/50 text-primary transition-transform duration-500 group-hover:scale-110 group-hover:bg-primary/10">
                  <benefit.icon className="h-10 w-10" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl font-bold font-default text-foreground">
                  {benefit.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="relative z-10 text-center">
                <p className="text-muted-foreground font-default leading-relaxed">
                  {benefit.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

        <div className="mt-16 text-center">
          <Button asChild size="lg" className="rounded-full px-8 group">
            <Link to="https://wa.me/34624990509">
              Solicitar Diagnóstico
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}